import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import DashboardView from '@/views/DashboardView.vue'
import LoginView from '@/views/LoginView.vue'
import InfoView from '@/views/InfoView.vue'
import ReportsView from '@/views/reports/ReportsView.vue'
import CreateReport from '@/views/reports/CreateReportView.vue'
import ReportWeeklyDetailsView from '@/views/reports/ReportWeekView.vue'
import ReportsOverview from '@/views/reports/ReportsOverview.vue'
import MobilizationView from '@/views/MobilizationView.vue'
import PlanView from '@/views/PlanView.vue'
import applicationUserManager from '../core/applicationusermanager'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      hideMenu: true
    }
  },
  {
    path: '/info',
    name: 'infoView',
    component: InfoView,
    meta: { requiresAuth: true }
  },
  {
    path: '/reports',
    name: 'reportsView',
    component: ReportsView,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'reportsOverview',
        component: ReportsOverview,
        meta: { requiresAuth: true }
      },
      {
        path: 'create/:type',
        name: 'createReport',
        component: CreateReport,
        meta: { requiresAuth: true }
      },
      {
        path: 'week/:type',
        name: 'reportDetails',
        component: ReportWeeklyDetailsView,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/mobilization',
    name: 'mobilizationView',
    component: MobilizationView,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'plan',
        name: 'planView',
        component: PlanView,
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = await applicationUserManager.isAuthenticated()
  if (requiresAuth && !isAuthenticated) {
    next('/login') // Omdiriger til login, hvis brugeren ikke er autentificeret.
  } else {
    next() // tillad navigation
  }
})

export default router
